import Vue from 'vue'
import axios from 'axios'
import qs from 'qs';
import {Toast} from "vant";
import {setStore,setCookie,getCookie} from "../utils/mUtil";
import { severUrl,redisUrl } from "@/router/Constant";

// baseUrl
var baseUrl = severUrl +  "/mobileapi/control/";        // sever


// axios default settings
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000

// if any global code status deal with "then"
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl + url, qs.stringify(params))
      .then(res => {
        resolve(res.data);
        if (res.data._ERROR_MESSAGE_ == "用户未登录") {
          setStore('islogIn',false)
        }
      })
      .catch(err => {
        if (err.message == "Network Error" ) {
          Toast('网络在开小差');
        } else if (err.message.indexOf('timeout')!=-1){
          Toast.fail('连接超时');
        }
        reject(err);
      });
  });
};

export function postSpecial(baseSet,url,params) {
  return new Promise((resolve, reject) => {
    axios.post( redisUrl + baseSet + url, qs.stringify(params))
      .then(res => {
        resolve(res.data);
        if (res.data._ERROR_MESSAGE_ == "用户未登录") {
          setStore('islogIn',false)
        }
      })
      .catch(err => {
        if (err.message == "Network Error" ) {
          Toast('网络在开小差');
        } else if (err.message.indexOf('timeout')!=-1){
          Toast.fail('连接超时');
        }
        reject(err);
      });
  });
};

export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};




// WEBPACK FOOTER //
// ./src/router/service.js